import { useState } from 'react';
import PropTypes from 'prop-types';
import { Menu, IconButton, Box } from '@mui/material';
import ForumIcon from '@mui/icons-material/Forum';
import { styled, alpha } from '@mui/material/styles';
import { getInvoiceNotes } from '../../../api/invoicing';
import MessageItem from '../../../reusable-components/ChatBox/MessageItem'

Notes.propTypes = {
  rowId: PropTypes.number,
};

export default function Notes({ rowId }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  const [notes, setNotes] = useState([]);

  const open = Boolean(anchorEl);

  const handleClickOpen = (event) => {
    if (loading) return;
    setLoading(true);
    getInvoiceNotes(rowId).then((response) => {
      setNotes(response.data);
      setLoading(false);
    });
    event.openTicket = true;
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setNotes([]);
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={handleClickOpen}
        sx={{
          opacity: 0.8,
        }}
        disabled={loading}
      >
        <ForumIcon width={28} height={28} color="info" />
      </IconButton>

      {notes?.length > 0 && (
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            'aria-labelledby': 'demo-customized-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <Box sx={{ overflowY: 'auto', maxHeight: '100%', width: '250px', my: 1 }} >
            {notes.map((note, idx) => (
              <MessageItem
                key={idx}
                message={{
                  fullName: note.user.fullName,
                  id: note.id,
                  note: note.note ?? '',
                  sentBy: note.user.email,
                  sentOn: note.dateAdded,
                  parentCommentId: note.parentCommentId,
                }}
                messages={notes}
              />
            ))}
          </Box>
        </StyledMenu>
      )}
    </>
  );
}

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    maxHeight: 300,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(214, 211, 211) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));
